export const classes = {
  wrapper: 'relative flex grow overflow-hidden min-h-0',
  scene: 'grow bg-grey-2 dark:bg-white/[0.05]',
  message:
    'place-center size-full text-xl text-grey-8 dark:text-mauve-1 absolute top-0 left-0 z-10 backdrop-blur-lg transition-all',
};
